var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Layout',[_c('PrivateHeader'),_c('Content',{style:({'min-height':_vm.height+'px'})},[_c('router-view',{ref:"router-view",on:{"changetab":_vm.changeTab}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }